import { useContext } from 'react';
import { PeopleChartsDataContext } from '../contexts/PeopleChartsDataContext';

export const usePeopleChartsDataContext = () => {
    return useContext(PeopleChartsDataContext);
};
